import { useMarketNavigate } from "Infrastructure/Routes/Hooks/useMarketNavigate";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMarketListQuery } from "Market/Api/Query/useMarketListQuery";
import { getMarketFromPath } from "Market/Utilities/getMarketFromPath";
import { Hello } from "Market/Widgets/Hello";
import { MarketSelectCard } from "Market/Widgets/MarketSelectCard";
import { OrderPaths } from "Order/Routes/Routing";
import { useUser } from "Settings/User/Api/Query/useUserProfileQuery";
import { Grid2, Stack, Typography } from "@mui/material";

const marketSelectResource = Resources.base.market.shared.select;

export function MarketSelectPage() {
	const { t } = useResource();
	const urlPath = getMarketFromPath();
	const { data: markets, isLoading: isMarketLoading } = useMarketListQuery();
	const { user, isLoading } = useUser();
	const marketNavigate = useMarketNavigate();

	if (!user || isLoading) {
		return null;
	}

	if (user.preselectedMarketId) {
		const preselectedMarket = markets?.find(
			(m) => m.id === user.preselectedMarketId,
		);

		if (preselectedMarket && !urlPath) {
			marketNavigate(OrderPaths.Index.path, preselectedMarket.urlPath);
			return null;
		}
	}

	return (
		<Stack
			justifyContent="center"
			alignItems="center"
			rowGap={5}
			alignSelf="center"
			width="100%"
		>
			<Stack justifyContent="center" textAlign="center" rowGap="12px">
				<Hello name={user.name} />
				<Typography variant="h3" fontWeight="500">
					{t(marketSelectResource.selectMarket)}
				</Typography>
			</Stack>
			<Grid2
				container
				spacing={2}
				justifyContent="center"
				padding={2}
				width="100%"
			>
				{!isMarketLoading &&
					markets?.map((market, index) => (
						<Grid2 key={market.id} size={{ xs: 4, sm: 3, md: 2 }}>
							<MarketSelectCard
								index={index}
								market={market}
								onClick={() => {
									marketNavigate(OrderPaths.Index.path, market.urlPath);
								}}
							/>
						</Grid2>
					))}
			</Grid2>
		</Stack>
	);
}
